<div class="sv-question-map-polygon">
  <div class="map-header" *ngIf="!model.isReadOnly">
    <div class="map-status">
      <div
        class="status-badge"
        [class.is-closed]="isPolygonClosed"
        [class.is-drawing]="isDrawingMode && !isPolygonClosed"
      >
        <span class="status-dot"></span>
        <span class="status-label">
          {{ isPolygonClosed ? 'Area definita' : 'Disegna sulla mappa' }}
        </span>
      </div>
      <span class="map-hint" *ngIf="isDrawingMode && !isPolygonClosed">
        {{ polygonPath.length >= 3 ? 'Aggiungi altri punti oppure tocca "Chiudi area"' : 'Tocca la mappa per posizionare i punti' }}
      </span>
    </div>

    <div class="map-actions">
      <!-- Annulla ultimo punto -->
      <button
        type="button"
        class="sv-btn-action sv-btn-undo"
        (click)="undoLastPoint()"
        *ngIf="isDrawingMode && !isPolygonClosed && polygonPath.length > 0"
        title="Annulla ultimo punto"
      >
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 14 4 9l5-5" />
          <path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H11" />
        </svg>
        <span>Annulla</span>
      </button>

      <!-- Chiudi area esplicito (fondamentale su smartphone per non forzare il tap sul primo punto) -->
      <button
        type="button"
        class="sv-btn-action sv-btn-close-area"
        (click)="closePolygon()"
        *ngIf="isDrawingMode && !isPolygonClosed && polygonPath.length >= 3"
      >
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <span>Chiudi area</span>
      </button>

      <!-- Ridisegna area -->
      <button
        type="button"
        class="sv-btn-action sv-btn-reset"
        (click)="clearPolygon()"
        *ngIf="polygonPath.length > 0"
      >
        <svg
          class="btn-icon"
          viewBox="0 0 24 24"
          width="14"
          height="14"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
          <path d="M3 3v5h5" />
        </svg>
        <span>Ridisegna area</span>
      </button>
    </div>
  </div>

  <div class="map-container" [class.is-drawing]="isDrawingMode && !isPolygonClosed">
    <div #map class="leaflet-map"></div>
  </div>
</div>
